export default __webpack_public_path__ + "static/benifitImage1-f20f4cd94c33d50dd7eda6aae76c44ea.png";